import { FlashMessageService } from "zoox-infra";
import { zPaySmsMessageForm } from "zoox-components";
import PersonService from "@/service/person-service";
import PaymentService from "@/service/payment-service";

export default {
  name: "ValidateRegistrationDialog",
  components: {
    "z-pay-sms-message-form": zPaySmsMessageForm
  },
  props: {
    openDialog: {
      type: Boolean
    },
    personProp: {
      type: Object,
      default: () => {
        return {
          name: "",
          documentTypeId: "",
          documentNumber: "",
          password: "",
          mobileCountryCode: "",
          mobileCityCode: "",
          mobilePhoneNumber: "",
          phoneNumber: "",
          email: "",
          companyId: ""
        };
      }
    }
  },
  data() {
    return {
      success: false,
      personService: new PersonService(),
      paymentService: new PaymentService(),
      person: {
        companyId: this.personProp.companyId,
        documentTypeId: this.personProp.documentTypeId,
        documentNumber: this.personProp.documentNumber
      }
    };
  },
  methods: {
    close() {
      this.$emit("closeValidateRegistrationDialog");
    },
    async validateCode(data) {
      await this.personService.confirmRegistration(data).then(resp => {
        if (resp && resp.id) {
          FlashMessageService.success(
            this.$t("REGISTRATION.SUCCESS_REGISTRATION_MESSAGE")
          );
          setTimeout(() => {
            this.close();
          }, 2000);
        }
      });
    },
    async forgotCode() {
      const data = {
        documentTypeId: this.person.documentTypeId,
        documentNumber: this.person.documentNumber,
        companyId: this.person.companyId
      };
      this.personService.resendRegistrationCode(data).then(() => {
        FlashMessageService.success(
          this.$t("PAYMENT_SOLICITATION.PIN_GENERATED")
        );
      });
    }
  }
};
